import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Process = ({ listProcess }) => {
    return (
        <div className="teboil-process">
            <FullWrapper>
                <div className="teboil-processWrapper">
                    <div className="teboil-processTitle">Процесс</div>
                    <div className="teboil-processInner">
                        <div className="teboil-processLeft">
                            {listProcess.map((item, index) => (
                                <div key={index}>
                                    <div
                                        className="teboil-processLeftItem"
                                        dangerouslySetInnerHTML={{ __html: item.text }}
                                        key={index}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="teboil-processRight">
                            <div className="teboil-processlist">Технологическая основа проекта</div>
                            <div className="teboil-processContent">
                                <div className="teboil-processFrameworks">
                                    <img
                                        src="/images/svg/teboil/bitrix.svg"
                                        alt="bitrix"
                                        className="teboil-processIcon"
                                    ></img>
                                    <div className="teboil-processName">1C-Bitrix</div>
                                </div>
                                <div className="teboil-processFrameworks">
                                    <img
                                        src="/images/svg/teboil/react.svg"
                                        alt="react"
                                        className="teboil-processIcon"
                                    ></img>
                                    <div className="teboil-processName">ReactJS</div>
                                </div>
                                <div className="teboil-processFrameworks">
                                    <img
                                        src="/images/svg/teboil/next.svg"
                                        alt="next"
                                        className="teboil-processIcon"
                                    ></img>
                                    <div className="teboil-processName">Next.js</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Process;
